export default {
    preview: 'Preview Front-end',
    logo_text: 'Medikon Conference Management System',
    exit: 'Safe Exit',
    submit: 'Submit Now',
    placeholder: 'Please enter ',
    search: 'Search',
    reset: 'Reset',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    operation: 'Operation',
    please_select: 'Please select',
    please_enter: 'Please enter ',
    please_upload: 'Please upload',
    serial_number: 'Serial Number',
    yes: 'Yes',
    no: 'No',
    operation_success: 'Operation Successful',
    positive_integer: 'Positive Integer',
    prev_step: 'Previous Step',
    next_step: 'Next Step',
    cancel: 'Cancel',
    show: 'Show',
    not_show: 'Hide',
    upload_image: 'Upload Image',
    clear: 'Clear',
    success: 'Success',
    fail: 'Failure',
    save: 'Save',
    male: 'Male',
    female: 'Female',
    close: 'Close',
    required_null: 'Required field cannot be empty',
    export: 'Export',
    details: 'Details'
};
